<template>
	<div class="inputBoxWrap">
		<select
			v-model.trim="value"
			v-on:focus="eventFocus"
			v-on:blur="eventBlur"
			:name="refs"
			:placeholder="item.label"
			v-bind:style="colorBorder"
		>
			<option value="" disabled selected>{{item.label}}</option>
			<option :key="index"
							:value="option.value"
							v-for="(option,index) in getRefValue(refs)">
				{{option.name}}
			</option>
		</select>
		<label>{{item.label}}</label>
		<p class="errorMsg" v-if="statusVuex[refs].ShowError">{{errorMsg}}</p>
	</div>
</template>
<script>
	import DataForInput from '@/store/Form/longFormOptions';
	import {mapGetters, mapState} from 'vuex'
	export default {
		name: "fmSelect",
		data: function () {
			return {
				item: DataForInput[this.refs],

			}
		},
		props: {
			refs: {
				type: String,
				default: 'null'
			},
			type:{
				type: String,
				default: 'form'
			},
			firstValueSetActive:{
				type:Boolean,
				default:false
			}
		},
		methods: {
			eventFocus(){
				// this.$palantir.trackInputFocus(this.refs);
				this.$store.dispatch('errorShow', {
					target: this.refs,
					value: false,
				});
			},
			eventBlur(){
				// this.$palantir.trackInputBlur(this.refs,this.valueVuex[this.refs]);
			}
		},
		computed: {
			inputFilter: function(){
				let out = [];
				if (this.refVuex.length > 0) {
						let refArray = this.refVuex.filter(key => key.fieldName == this.refs);
						if (refArray.length > 0) {
							out =JSON.parse(JSON.stringify(refArray[0].fieldValues));
						}
				}

					return out.sort((a,b)=>{
						return (a.sort !== undefined && b.sort !==undefined) ?
							parseInt(a.sort,10) - parseInt(b.sort,10)
							:0;
					});
			},
			status: function () {
				return this.statusVuex[this.refs].code;
			},
			errorMsg: function () {
				return this.statusVuex[this.refs].msg;
			},
			showErrorMessage() {
				return this.statusVuex[this.refs].ShowError;
			},
			colorBorder() {
				return (this.showErrorMessage && this.status !== 0) ? 'border-color:#ff00003d;' :'border-color: rgba(67, 172, 52, 0.5);';
			},
			value: {
				get() {
					return this.valueVuex[this.refs]
				},
				set(value) {
					this.$store.dispatch('saveSendData', {
						target: this.refs,
						value: value
					});

					this.$external.traceInput({
						action:165,
						refs:this.refs,
						value:value
					});
				}
			},
			errorStatus: function () {
				return false
			},
			...mapGetters(['getTargetFieldValue','getRefValue']),
			...mapState({
				valueVuex:  state => state.Form.sendData,
				statusVuex: state => state.Form.workData,
				refVuex:    state => state.Form.ref,
				rangeValueSummVuex: state => state.Deal.pdlSelectedAmount,
				rangeValuePeriodVuex: state => state.Deal.pdlSelectedPeriod,
				availablePeriods: state=> state.Deal.pdlPeriods,
			})
		},
		mounted(){
			if (this.firstValueSetActive) {
				this.value = this.inputFilter[0].value;
			}
		}
	}
</script>

<style scoped>
.errorMsg { color: red; font-size: 2.87vw; pointer-events: none;position: absolute; background: white;padding: 0 1.60vw; top: 11vw; left: 2.28vw }
.inputBoxWrap { position: relative }
.inputBoxWrap label { position: absolute; padding: 0 2.67vw ; top: 1px; font-size: 2.87vw; border-top-left-radius: 2.67vw; color: #869A95; pointer-events: none; transition: 0.3s ease-out; background: #FFFFFF; left: 2.28vw;opacity: 0;}
select:focus ~ label {top: -2vw ;}
select {display: block;width: 100%;box-sizing: border-box;border: 1px solid rgba(67, 172, 52, 0.5);padding: 4.41vw 5.88vw 4.41vw 5.88vw;margin-bottom: 4.71vw;font-size: 3.47vw;border-radius: 2.67vw}
@media (min-width: 760px) {
	select {padding: 0.89vw 1.61vw; border-radius: 10px; font-size: 1.13vw; margin-bottom: 1.29vw; color: #959595; width: 100% }
	select > option { font-size: 1vw }
	.errorMsg { font-size: 0.81vw; top: 2.8vw; left: 0.28vw; }
	.inputBoxWrap label { font-size: 0.81vw; color: #959595; padding: 0 }
  select:focus ~ label {top:-0.5vw}
}
@media (min-width: 1240px) {
  select {padding: 10px 17px; font-size: 14px; margin-bottom: 16px; width: 100%}
  select > option { font-size: 14px; }
  .errorMsg { font-size: 10px; top: 36px; left: 23px; padding: 0 }
  .inputBoxWrap label { font-size: 10px; padding: 0; left: 23px; opacity: 1}
  select:focus ~ label {top:-6px}
}

</style>
